import { GET, httpOk, PUT } from 'helpers/api';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function save() {
		await PUT('/admin/versions', data)
	}


	function handleChange(e, index) {
		var dataCopy = [...data]
		dataCopy[index]['version'] = e.target.value
		setData(dataCopy)
	}

	function handleRequiredChange(e, index) {
		var dataCopy = [...data]
		dataCopy[index]['required'] = e.target.checked
		setData(dataCopy)
	}

	async function getData() {
		const response = await GET('/admin/versions')
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getData()
	}, []);

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('versions')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						{data.map((item, index) => (
							<div className="col-3 mb-2" key={index}>
								<label>
									{item.type}
								</label>

								<input type="text" className="form-control mb-1" value={item.version} onChange={(e) => handleChange(e, index)} />

								<div className="d-flex justify-content-between align-items-center">
									<span className="fz-12">Обязательное обновление</span>

									<div className="form-check form-switch form-switch-md">
										<input type="checkbox" className="form-check-input"
											checked={item.required ? true : false}
											onChange={(e) => handleRequiredChange(e, index)} />
									</div>
								</div>
							</div>
						))
						}
					</div>

					<div className="d-flex justify-content-end">
						<button className="btn btn-primary" onClick={() => save()}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index